import type { ErrorTexts } from "@nexxt/app-kit";
import type { AccountSourceErrorCode, CampaignFunnelErrorCode, CrmErrorCode } from "@nexxt/contracts/crm";
import { m } from "../paraglide/messages.js";

// The words of the codes gateway-guestlist can answer with (ADR-046), registered at start (main.tsx): crm's, the only
// domain behind it (ADR-287 §2.2), with those of booking and of the directory it hands on as they are (ADR-299 §2,
// ADR-316 §4); the common ones are app-kit's. A code without a text does not compile.
export const errorTexts: ErrorTexts<CrmErrorCode | CampaignFunnelErrorCode | AccountSourceErrorCode> = {
  email_template_invalid: m.error_email_template_invalid,
  email_template_archived: m.error_email_template_archived,
  email_template_not_publishable: m.error_email_template_not_publishable,
  email_element_not_found: m.error_email_element_not_found,
  email_column_not_empty: m.error_email_column_not_empty,
  email_locale_exists: m.error_email_locale_exists,
  email_locale_missing: m.error_email_locale_missing,
  email_locale_default: m.error_email_locale_default,
  brand_kit_invalid: m.error_brand_kit_invalid,
  brand_kit_taken: m.error_brand_kit_taken,
  email_asset_invalid: m.error_email_asset_invalid,
  crm_send_invalid: m.error_crm_send_invalid,
  crm_send_status: m.error_crm_send_status,
  crm_send_empty: m.error_crm_send_empty,
  crm_send_dry_run_missing: m.error_crm_send_dry_run_missing,
  crm_send_confirmation: m.error_crm_send_confirmation,
  crm_send_test_address: m.error_crm_send_test_address,
  crm_send_not_configured: m.error_crm_send_not_configured,
  crm_move_link_taken: m.error_crm_move_link_taken,
  crm_move_link_invalid: m.error_crm_move_link_invalid,
  crm_contact_opted_out: m.error_crm_contact_opted_out,
  crm_document_page_invalid: m.error_crm_document_page_invalid,
  crm_document_status: m.error_crm_document_status,
  crm_document_incomplete: m.error_crm_document_incomplete,
  crm_document_invalid: m.error_crm_document_invalid,
  crm_share_revoked: m.error_crm_share_revoked,
  crm_share_revoke_pending: m.error_crm_share_revoke_pending,
  assistant_disabled: m.error_assistant_disabled,
  assistant_not_allowed: m.error_assistant_not_allowed,
  assistant_busy: m.error_assistant_busy,
  assistant_cap_reached: m.error_assistant_cap_reached,
  assistant_unavailable: m.error_assistant_unavailable,
  sales_campaign_archived: m.error_sales_campaign_archived,
  campaign_invitation_invalid: m.error_campaign_invitation_invalid,
  booking_link_contact_invalid: m.error_booking_link_contact_invalid,
  booking_link_not_sent: m.error_booking_link_not_sent,
  contact_invalid: m.error_contact_invalid,
};
